import loadable from '@loadable/component'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router'
import RootLayout from '@/layouts/root'
import { TreePage } from '@/pages/tree'
import { TreePage2 } from '@/pages/tree2'

const HomePage = loadable(() => import(/* webpackChunkName: 'home' */ '@/pages/home'))
const AboutPage = loadable(() => import(/* webpackChunkName: 'about' */ '@/pages/about'))
const NoMatch = loadable(() => import('@/components/no-match'))

export default function AppRouter() {
  return (
    <BrowserRouter basename={import.meta.env?.__BASENAME__ || ''}>
      <Routes>
        <Route path='/' element={<RootLayout />}>
          <Route index element={<Navigate to='/tree2' />} />
          <Route path='home' element={<HomePage />} />
          <Route path='about' element={<AboutPage />} />
          <Route path='tree' element={<TreePage />} />
          <Route path='tree2' element={<TreePage2 />} />
        </Route>
        <Route path='*' element={<NoMatch />} />
      </Routes>
    </BrowserRouter>
  )
}
